const generateRandomKey = (length: number, customCharacters?: string) => {
  let password = '';
  const characters =
    customCharacters ||
    'ABCDEFGHIJKLMNOPKRSTUVXWYZabcdefghijklmnopqrstuvxwyz0123456789!#%@&';

  for (let i = 0; i <= length; i++) {
    const index = Math.floor(Math.random() * characters.length);
    password += characters[index];
  }

  return password;
};

export default generateRandomKey;
